import { toNumber } from 'lodash';

export const getPetNumFromQueryString = (): number => {
  const params = new URLSearchParams(location?.search ?? '');
  return toNumber(params.get('i'));
};
